import React from 'react';
import { activeOfferFor, offersContent } from '../../data/products';
import Icon from '../Icon/Icon';
import './TopBar.css';

/* Announcement bar (Dadu's-style): one festive line with an inline CTA.
 *
 * Optional scheduling: settings.json may carry `announcementStart` and/or
 * `announcementEnd` as datetime strings (ISO 8601, e.g. "2026-08-01T00:00").
 * Either key may be absent, empty or unparseable — in every one of those
 * cases the bar shows, so a settings file without the keys behaves exactly
 * as it does today. Evaluated once per mount, which is all a page load needs. */
const parseAt = (value) => {
  const t = value ? Date.parse(value) : NaN;
  return Number.isNaN(t) ? null : t;
};

const isLive = ({ announcementStart, announcementEnd }, now = Date.now()) => {
  const from = parseAt(announcementStart);
  const to = parseAt(announcementEnd);
  if (from !== null && now < from) return false;
  if (to !== null && now > to) return false;
  return true;
};

const TopBar = () => {
  const offer = activeOfferFor(offersContent, 'announcement');
  const scrollBehavior = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  const scrollTo = (...ids) => {
    /* getElementById on a section that is not mounted returns null and the
       click becomes a silent no-op — fall through the list, then to the top. */
    const target = ids.map((id) => document.getElementById(id)).find(Boolean);
    if (target) target.scrollIntoView({ behavior: scrollBehavior });
    else window.scrollTo({ top: 0, behavior: scrollBehavior });
  };

  if (!offer?.announcement || !isLive({ announcementStart: offer.startsAt, announcementEnd: offer.endsAt })) return null;

  return (
    <div className="top-bar" role="region" aria-label="Announcement">
      <p>
        <span className="top-bar-copy">{offer.announcement}</span>
        {offer.ctaLabel && (
          <button className="top-bar-cta" onClick={() => scrollTo('order', 'custom-order')}>
            <span>{offer.ctaLabel}</span>
            <Icon name="arrow" size={15} strokeWidth={1.9} />
          </button>
        )}
      </p>
    </div>
  );
};
export default TopBar;
